import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/home/accounts/loans/$accountId',
)({
  staticData: {crumbKey: 'navigation.loan-account'},
});
